import { BadgeVariants } from "ds/components/Badge/types";
import { AnsibleTaskStatus } from "types/generated";

export const ANSIBLE_STATUS_BADGE_VARIANT: Record<AnsibleTaskStatus, BadgeVariants> = {
  [AnsibleTaskStatus.Changed]: "yellow",
  [AnsibleTaskStatus.Failed]: "red",
  [AnsibleTaskStatus.Ignored]: "fuchsia",
  [AnsibleTaskStatus.Ok]: "green",
  [AnsibleTaskStatus.Rescued]: "turquoise",
  [AnsibleTaskStatus.Skipped]: "blue",
  [AnsibleTaskStatus.Unreachable]: "orange",
};

export enum FilterItemKeys {
  NAME = "name",
}

export const FILTER_ITEMS_DICTIONARY: Partial<Record<FilterItemKeys, string>> = {
  [FilterItemKeys.NAME]: "name",
};

export const LOADING_THRESHOLD = 18;
